import { AppState } from '../meta-reducer/index';
import { map, mergeMap, catchError } from 'rxjs/operators';
import { Injectable } from "@angular/core"
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { AccountApiService, ApiService } from '../../providers/api.service';
import * as UserRewardActions from './user.rewards.actions';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
@Injectable()
export class UserRewardsEffects {

  constructor(private actions$: Actions, private _accountApiService: AccountApiService, private store: Store<AppState>) { }
  
  loadRewards$ = createEffect(() => this.actions$
    .pipe(
      ofType(UserRewardActions.userRewardRequested),
      mergeMap((action) => {
        return this._accountApiService.getUserRewards(action.queryParams)
          .pipe(
            catchError(error => {
              this.store.dispatch(UserRewardActions.userRewardLoadingError({ errorMessage: error?.message }))
              return of({
                data: []
              })
            })
          )
      }),
      map(rewards => {
        return UserRewardActions.userRewardLoaded({ userReward: rewards?.data?.data ? rewards.data.data : [], hasNextPage: rewards?.data?.hasNextPage, isLoaded: true })
      }),
    ))
}
